
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { useDispatch, useSelector } from "react-redux";
import {
    setDialogPasswordResetMailVisible
} from "../Slice/DialogSlice";
import { AppDispatch, RootState } from "../Store";

export default function AuthDialogPasswordResetMail() {

    const passwordResetMailVisible = useSelector((state: RootState) => state.authReducer.dialog.passwordResetMailVisible);
    const enteredResetMailAddress = useSelector((state: RootState) => state.authReducer.auth.enteredResetMailAddress);
    const dispatch = useDispatch<AppDispatch>();

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <div>
                <h3>Bitte überprüfen Sie Ihre Mails!</h3>
            </div>
        </div>
    );

    const footerContent = (<></>);

    return (
        <Dialog
            header={headerElement}
            footer={footerContent}
            visible={passwordResetMailVisible}
            style={{ width: '50vw' }}
            onHide={() => dispatch(setDialogPasswordResetMailVisible(false))}
        >
            <i className={classNames("bi bi-envelope")} style={{ fontSize: '2.5rem' }}></i>
            <p>
                Es wurde eine E-Mail versendet an {enteredResetMailAddress}
            </p>
        </Dialog>
    )
}